import axiosClient from "../apiClient";

/**
 * Analytics API. Each endpoint returns everything one dashboard page renders,
 * so a page is a single request and its tiles are mutually consistent.
 *
 * Data originates in BigQuery views (see app/docs/analytics/bigquery/) and is
 * cached server-side for 30 minutes.
 */

// Drops empty filters so the request URL stays clean and the server's
// "unbounded" default applies rather than an empty string.
const toQuery = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.from) params.append("from", filters.from);
  if (filters.to) params.append("to", filters.to);
  if (filters.platform) params.append("platform", filters.platform);
  const query = params.toString();
  return query ? `?${query}` : "";
};

const get = (path, filters) =>
  axiosClient.get(`admin/analytics/${path}${toQuery(filters)}`);

/** Headline KPIs. Lifetime totals — not affected by the date filter. */
export const getAnalyticsSummary = (filters) => get("summary", filters);

/** Creation funnel: steps, drop-off rates, volume over time, upload failures. */
export const getFunnelAnalytics = (filters) => get("funnel", filters);

/** New users by channel and country, plus the activation funnel. */
export const getAcquisitionAnalytics = (filters) => get("acquisition", filters);

/** Template and category performance. */
export const getContentAnalytics = (filters) => get("content", filters);

/** Retention, active users, north star. Sparse until there is enough history. */
export const getEngagementAnalytics = (filters) => get("engagement", filters);

/** Paywall and onboarding funnels. */
export const getConversionAnalytics = (filters) => get("conversion", filters);

/**
 * Drop the server-side cache so the next request re-queries BigQuery. Costs a
 * full scan per view, so this is a deliberate button, never a poll.
 */
export const refreshAnalytics = () => axiosClient.post("admin/analytics/refresh");
